export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LOT_EXPORT_IMPOSSIBLE_INVALID_ACCOUNTING_WRITING') === 0) {
      messages.push({
        message: 'listeDetailLotsComptable.msgError.invalidAccounting',
      });
    }
    if (message.indexOf('LOT_EXPORT_FILE_NOT_FOUND') === 0) {
      messages.push({
        message: 'listeDetailLotsComptable.msgError.fileNotFound',
      });
    }
    if (message.indexOf('IBIZA_ERROR') === 0) {
      const elements = message.split('|')[0].split('@');
      const lotLibelle = elements[1];
      const errorMessage = elements[2];
      const errorReference = elements[3];
      messages.push({
        message: 'listeDetailLotsComptable.msgError.ibizaError',
        parametres: {
          lotLibelle: lotLibelle,
          errorMessage: errorMessage,
          errorReference: errorReference,
        },
      });
    }
  });
}
